import type { Category } from '~/models';

import { useNuxtApp } from '#app';

const useCategoryStore = defineStore('customer-category', () => {
  const { $http } = useNuxtApp();

  const list = (): Promise<Category[] | null> => {
    return $http.category.list({
      displayIn: 'ONLINE',
      availableNow: true,
      onlyMains: true,
      includeOffer: true
    });
  };

  return {
    list
  };
});

export { useCategoryStore };
